import InitApi from "api/InitApi";
import ServerErrors from "components/SeverErrors";
import toast from "react-hot-toast";
import { useMutation, useQueryClient } from "react-query";
import { useHistory } from "react-router-dom";
import { reactLocalStorage } from "reactjs-localstorage";
import useTokenStore from "store/tokenStore";
import useResolveGiftRecipientByEmail from "./useResolveGiftRecipientByEmail";

const useGiftBook = () => {
	const queryClient = useQueryClient();
	const { accessToken } = useTokenStore();
	const history = useHistory();
	const { mutateAsync: resolveRecipientByEmail } = useResolveGiftRecipientByEmail();

	const gift = async ({ bookId, recipientQuery, giftMessage = null, recipientUserId = null }) => {
		const instance = await InitApi({ accessToken });

		let recipientId = recipientUserId;
		if (!recipientId) {
			const recipient = await resolveRecipientByEmail(recipientQuery);
			if (!recipient?.id) {
				throw new Error("Recipient not found. Please confirm the email or username and try again.");
			}
			recipientId = recipient.id;
		}

		const payload = {
			recipient_user_id: recipientId,
			gift_message: giftMessage || undefined,
			source_type: "purchase",
		};

		const response = await instance.post(`books/${bookId}/gift`, payload);
		return response;
	};

	return useMutation(gift, {
		onSuccess: async ({ data: body }, variables) => {
			await queryClient.invalidateQueries(["purchased"]);
			await queryClient.invalidateQueries(["books", "my-library"]);
			await queryClient.invalidateQueries(["books", variables?.bookId]);
			await queryClient.invalidateQueries(["books"]);
			toast.success(body?.message || "Book gifted successfully");
		},
		onError: async (error) => {
			if (error?.message === "Recipient not found. Please confirm the email or username and try again.") {
				toast.error(error.message);
				return;
			}

			toast.error(
				<ServerErrors
					errorMessage={error?.response?.data?.message || error?.message}
					errors={error?.response?.data?.data}
				/>,
				{
					className: "max-w-max",
				}
			);

			if (error?.response?.data?.message === "Unauthenticated.") {
				reactLocalStorage.clear();
				history.push("/");
			}
		},
	});
};

export default useGiftBook;
